'use strict';

var helper = require('../helper');

module.exports = {

    // Cart Interactions
    pushCheckoutButtonsFromCartInteraction (name, location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '2',
            'eventname': 'checkout_express_start',
            'type': name,
            'position': location || 'from_cart'
        };

        helper.log('Pushing click impression:', true);
        helper.push(pushObject);
    },

    pushCartAppliedCouponCode (code, data, where) {
        if (data.isLoyalty) {
            helper.push({
                'event': 'GAevent',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'eventID': '23',
                'eventname': 'coupon',
                'action': data.action || 'remove',
                'coupon': code,
                'label': 'loyalty' + code,
                'position': where
            });
        } else {
            let pushObject = {
                'event': 'GAevent',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'eventID': '23',
                'eventname': 'coupon',
                'action': data.btnAction || data.action || 'view',
                'coupon': code,
                'position': where
            };

            if (data.label || code === 'no_coupon_code') {
                pushObject.label = data.label || 'no_coupon_code';
            }

            helper.log('Pushing coupon code applied impression: \'' + code + '\'', true);
            helper.push(pushObject);
        }
    },

    pushGiftKit (quantity) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '122',
            'eventname': 'self_gift',
            'action': 'add',
            'label': quantity
        };

        helper.log('Pushing buy gift paper: ', true);
        helper.push(pushObject);
    },

    pushShippingMoreInfo (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '123',
            'eventname': 'shipping',
            'action': 'more_info',
            'category': topic
        };

        helper.log('Pushing more shipping info: ', true);
        helper.push(pushObject);
    },

    pushPaymentMoreInfo (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '137',
            'eventname': 'payment',
            'label': 'info_on_card_saving'
        };

        helper.log('Pushing more payment info: ', true);
        helper.push(pushObject);
    },

    pushShippingMethodsMoreInfo () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '118',
            'eventname': 'shipping_info',
            'category': 'shipping_methods',
            'action': 'more_info',
            'position': 'from_cart'
        };

        helper.log('Pushing shipping methods more info click', true);
        helper.push(pushObject);
    },

    pushProductsInsideGiftWrap (productsname, skus) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '121',
            'eventname': 'gift_wrap',
            'action': 'insert_the_product_inside_to_the_gift_wrap',
            'product_id': skus
        };

        helper.log('Pushing products in gift wrap: ', true);
        helper.push(pushObject);
    },

    pushOrderReviewProceed () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '138',
            'eventname': 'order_review_proceed'
        };

        helper.log('Pushing order review proceed: ', true);
        helper.push(pushObject);
    },

    pushOrderReview (action, where) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '139',
            'eventname': 'review_order',
            'action': action,
            'position': where
        };

        helper.log('Pushing order review: ', true);
        helper.push(pushObject);
    },

    // Minicart
    pushMinicartCheckoutClickInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '1',
            'eventname': 'minicart_cart',
            'type': name
        };

        helper.log('Pushing click impression:', true);
        helper.push(pushObject);
    },

    pushFastShippingMethodClickInteraction (type, user, name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '75',
            'eventname': 'checkout_express_shipping',
            'step': 'shipping_method',
            'shipping_method': type,
            'type': user || 'not_available',
            'store': name
        };

        helper.log('Pushing fast checkout shipping choice actions: ', true);
        helper.push(pushObject);
    },

    pushFastPaymentClickInteraction (method, user) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '76',
            'eventname': 'checkout_express_terms_and_conditions',
            'step': 'terms_and_conditions_of_sale',
            'payment_method': method,
            'type': user || 'not_available'
        };

        helper.log('Pushing fast checkout payment actions: ', true);
        helper.push(pushObject);
    },

    pushChangeShippingFastInteraction (method, user) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '77',
            'eventname': 'shipping_address',
            'action': 'change',
            'shipping_method': method,
            'position': 'fast_checkout',
            'type': user || 'not_available'
        };

        helper.log('Pushing change shipping fast checkout: ', true);
        helper.push(pushObject);
    },

    pushBeginCheckout (data) {
        let pushObject = {
            'event': 'begin_checkout',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'upselling_message': data.upselling_message,
            'ecommerce': {
                'currency': data.currency,
                'value': data.value,
                'coupon': data.coupon,
                'items': data.items
            }
        };

        helper.log('Pushing begin checkout', true);
        helper.push({ecommerce: null});
        helper.push(pushObject);
    },

    pushCompleteThePromoInteraction (promo, location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '179',
            'eventname': 'complete_promo',
            'label': promo,
            'position': location
        };

        helper.log('Pushing complete the promo action: ', true);
        helper.push(pushObject);
    },

    // 7.160 CART / RE-ORDER
    pushCartReOrder (tab) {
        helper.log('Pushing cart - order again');
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '184',
            'eventname': 'shopping_bag',
            'label': tab
        });
    }
};
